

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null,
    token: null,
    bookings: null,
}

export const authSlice  = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setLogin: ( state, action ) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
        },
        setLogout: ( state ) => {
            state.user = null;
            state.token = null;
        },
        setBookings: (state, action) => {
            state.bookings = action.payload.bookings;
        }
    }
});

export const { setLogin, setLogout, setBookings } = authSlice.actions;
export default authSlice.reducer;